export const isOnMobile = () =>
  /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
export const isOnDesktop = () => !isOnMobile();
export const isMac = () => navigator.userAgent.indexOf('Mac OS') !== -1;
